// ---------------------------------------------------------------------------
// SPORTS — simple, easy-to-update categories and messaging.
// Barverse has TWO big TVs with sports: keep it part of the brand, never
// overstated. No live schedule, no invented packages or guarantees.
// ---------------------------------------------------------------------------
export const SPORTS_CATEGORIES = [
  { abbr: "NFL", name: "NFL" },
  { abbr: "NBA", name: "NBA" },
  { abbr: "MLB", name: "MLB" },
  { abbr: "NHL", name: "NHL" },
  { abbr: "CFB", name: "College Football" },
  { abbr: "CBB", name: "College Basketball" },
  { abbr: "SOC", name: "Soccer" },
  { abbr: "MAJOR", name: "Major Sporting Events" },
];

export const SPORTS_SUPPORT = "Drinks. Tacos. Game on.";

export const SPORTS_DISCLAIMER =
  "Game availability and programming vary by Barverse location and are subject to change. Not every game or event is guaranteed to be shown — contact your local Barverse to confirm what's on.";
